import { Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomizedTables from "./Table";

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: "20px",
    width: "80%",
    minWidth: "fit-content",
    "@media print": {
      padding: 0,
      height: "190mm",
      width: "100%",
      breakInside: "avoid",
      colorAdjust: "exact",
      pageBreakBefore: "always",
    },
  },
  header: {
    padding: "10px 30px",
    fontWeight: "bold",
    fontSize: "14px",
  },
};
export type GradeAssignmentType = [string, number, number, number][];
interface IProps {
  data: GradeAssignmentType;
  isLoading: boolean;
}
const GradeAssignment = ({ data, isLoading = true }: IProps) => {
  const { t } = useTranslation();
  const headerData = [
    t("gradeName"),
    t("Number of completed lessons"),
    t("Total number of lessons' questions"),
    t("Total number of freeplays' Questions"),
  ];

  return (
    <Typography component="div" sx={customStyles.root}>
      {isLoading ? (
        <Skeleton variant="rectangular" height={250} width="90%" />
      ) : data.length ? (
        <>
          <Typography component="h1" sx={customStyles.header}>
            {t("Assignment Data By Grade")}
          </Typography>
          <CustomizedTables headerData={headerData} rowsData={data} />
        </>
      ) : null}
    </Typography>
  );
};

export default GradeAssignment;
